<template>
  <a-card :bordered="true">
    <!-- 表格内容操作 start -->
    <!-- <div class="table-operator">
      <a-button type="primary" style="margin-right:15px;">全部导出</a-button>
      <a-button type="dashed" @click="toggleTableAlert()">{{ optionAlertShow && '关闭' || '开启' }}多选</a-button>
      <a-dropdown v-if="optionAlertShow && selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1"><a-icon type="file-zip" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown>
      <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group>
    </div> -->
    <!-- 表格内容操作 end -->
    <a-tabs default-active-key="1">
      <a-tab-pane key="1" tab="待批改">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit1">
            <a-row :gutter="48">
              <!-- 输入关键词查找 -->
              <a-col :md="6" :sm="24">
                <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入老师名称搜索" v-model="queryParam1.tname"></a-input>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
              </template>
              <!-- 展开或者收起筛选项 start -->
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">查询</a-button>
                  <a-button style="margin-left: 8px" @click="reset1">重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
              <!-- 展开或者收起筛选项 end -->
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          ref="table1"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData1"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="zwjc" slot-scope="text, record">
            {{ record.student_data.zwjc }}
          </span>
          <span slot="zwmb" slot-scope="text, record">
            {{ record.student_data.zwmb }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.teacher_data.qq }}
          </span>
          <span slot="zwpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.zwpath" target="_blank">下载原稿</a>
            <span v-if="text === ''">暂未上传</span>
            <!-- <a-icon style="margin-left:10px;font-size:18px;" title="点击上传课件" type="upload" @click="showZwModal(record)"/> -->
          </span>
          <span slot="hgpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.hgpath" target="_blank">下载回稿</a>
            <span v-if="text === ''">--</span>
          </span>
          <span slot="status" slot-scope="text">
            <span v-if="text === 1">待签收</span>
            <span v-if="text === 2">待批改</span>
          </span>
          <span slot="action" slot-scope="text, record">
            <a-popconfirm
              v-if="record.status === 1"
              title="确定取消预约"
              @confirm="handleCancelOk(record.sub_id)"
              okText="确认"
              cancelText="取消"
            >
              <a href="#">取消预约</a>
            </a-popconfirm>
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="2" tab="已完成">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit2">
            <a-row :gutter="48">
              <!-- 输入关键词查找 -->
              <a-col :md="6" :sm="24">
                <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入老师名称搜索" v-model="queryParam2.tname"></a-input>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
              </template>
              <!-- 展开或者收起筛选项 start -->
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">查询</a-button>
                  <a-button style="margin-left: 8px" @click="reset2">重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
              <!-- 展开或者收起筛选项 end -->
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          ref="table2"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData2"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="zwjc" slot-scope="text, record">
            {{ record.student_data.zwjc }}
          </span>
          <span slot="zwmb" slot-scope="text, record">
            {{ record.student_data.zwmb }}
          </span>
          <span slot="oetime" slot-scope="text, record">
            {{ record.student_data.oetime }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.teacher_data.qq }}
          </span>
          <span slot="status">
            已完成
          </span>
         <span slot="zwpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.zwpath" target="_blank">下载原稿</a>
            <span v-if="text === ''">暂未上传</span>
          </span>
          <span slot="hgpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.hgpath" target="_blank">下载回稿</a>
            <span v-if="text === ''">--</span>
          </span>
         <span slot="action" slot-scope="text, record">
            <a v-if="record.teacher_point===0" @click="showEvaluateModal(record)">老师评价</a>
            <span v-if="record.teacher_point!==0">--</span>
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
      <a-tab-pane key="3" tab="已取消">
        <!-- 表格筛选 start -->
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @submit="handleSubmit2">
            <a-row :gutter="48">
              <!-- 输入关键词查找 -->
              <a-col :md="6" :sm="24">
                <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入老师名称搜索" v-model="queryParam2.tname"></a-input>
                </a-form-item>
              </a-col>
              <template v-if="advanced">
              </template>
              <!-- 展开或者收起筛选项 start -->
              <a-col :md="!advanced && 6 || 24" :sm="24">
                <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
                  <a-button type="primary" htmlType="submit">查询</a-button>
                  <a-button style="margin-left: 8px" @click="reset2">重置</a-button>
                  <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                    {{ advanced ? '收起' : '展开' }}
                    <a-icon :type="advanced ? 'up' : 'down'"/>
                  </a> -->
                </span>
              </a-col>
              <!-- 展开或者收起筛选项 end -->
            </a-row>
          </a-form>
        </div>
        <div class="table-operator">
        </div>
        <!-- 表格筛选 end -->
        <!-- 表格 start -->
        <tcg-table
          style="margin-top:-10px;"
          ref="table3"
          size="default"
          rowKey="sub_id"
          :columns="columns"
          :data="loadData3"
          bordered
        >
          <span slot="classification" slot-scope="text, record">
            {{ record.course_data.classification }}
          </span>
          <span slot="cname" slot-scope="text, record">
            {{ record.course_data.cname }}
          </span>
          <span slot="teacher" slot-scope="text, record">
            {{ record.teacher_data.english_name }}
          </span>
          <span slot="student" slot-scope="text, record">
            {{ record.student_data.english_name }}
          </span>
          <span slot="zwjc" slot-scope="text, record">
            {{ record.student_data.zwjc }}
          </span>
          <span slot="zwmb" slot-scope="text, record">
            {{ record.student_data.zwmb }}
          </span>
          <span slot="oetime" slot-scope="text, record">
            {{ record.student_data.oetime }}
          </span>
          <span slot="qq" slot-scope="text, record">
            {{ record.teacher_data.qq }}
          </span>
          <span slot="status">
            已取消
          </span>
         <span slot="zwpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.zwpath" target="_blank">下载原稿</a>
            <span v-if="text === ''">暂未上传</span>
          </span>
          <span slot="hgpath" slot-scope="text, record">
            <a v-if="text !== ''" :href="record.hgpath" target="_blank">下载回稿</a>
            <span v-if="text === ''">--</span>
          </span>
          <span slot="action">
            --
          </span>
        </tcg-table>
        <!-- 表格 end -->
      </a-tab-pane>
    </a-tabs>
    <a-modal :confirm-loading="confirmLoading" v-if="zwpathVisible" :visible="zwpathVisible" title="上传原稿" @ok="handleZwpathOk" @cancel="zwpathVisible = false">
      <a-upload
        name="file"
        :multiple="false"
        list-type="text"
        action="/index.php/upload_file/uploadFile?type=zwpath"
        @change="handleZwpathChange"
      >
        <a-button><a-icon type="upload" />点击上传原稿</a-button>
      </a-upload>
    </a-modal>
    <a-modal :confirm-loading="confirmLoading" v-if="evaluateVisible" :visible="evaluateVisible" title="老师评价" @ok="handleEvaluateOk" @cancel="evaluateVisible = false">
      评分：<a-rate v-model="evaluateData.teacher_point" />
      <br />
      <br />
      <a-textarea style="display:inline-block" v-model="evaluateData.evaluate" placeholder="请填写评价" :rows="4" />
    </a-modal>
  </a-card>
</template>
<script>
import { getPre, getList, saveZwpath, saveEvaluate, saveCancel } from '@/api/subscribe'
import { TcgTable } from '@/components'
import notification from 'ant-design-vue/es/notification'
import _ from 'lodash'

export default {
  components: {
    TcgTable
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // id
      id: '',
      // 字典
      dict: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam1: {
        ctype: '作文',
        status: 'WAIT',
        tname: ''
      },
      queryParam2: {
        ctype: '作文',
        status: 'DONE',
        tname: ''
      },
      queryParam3: {
        ctype: '作文',
        status: 'CANCEL',
        tname: ''
      },
      // 表头
      columns: [
        {
          title: '预约日期',
          dataIndex: 'days'
        },
        {
          title: '旺旺名',
          dataIndex: 'uname'
        },
        {
          title: '课程名称',
          dataIndex: 'cname'
        },
        {
          title: '老师',
          dataIndex: 'teacher',
          scopedSlots: { customRender: 'teacher' }
        },
        {
          title: '联系方式',
          dataIndex: 'qq',
          scopedSlots: { customRender: 'qq' }
        },
        {
          title: '上传时间',
          dataIndex: 'zwtime'
        },
        {
          title: '回稿时间',
          dataIndex: 'hgtime'
        },
        {
          title: '原稿',
          dataIndex: 'zwpath',
          scopedSlots: { customRender: 'zwpath' }
        },
        {
          title: '回稿',
          dataIndex: 'hgpath',
          scopedSlots: { customRender: 'hgpath' }
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '老师得分',
          dataIndex: 'teacher_point',
          scopedSlots: { customRender: 'teacher_point' }
        },
        {
          title: '评价内容',
          dataIndex: 'evaluate',
          scopedSlots: { customRender: 'evaluate' }
        },
        {
          title: '操作',
          dataIndex: 'sub_id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData1: parameter => {
        return getList(Object.assign(parameter, this.queryParam1))
          .then(res => {
            return res
          })
      },
      loadData2: parameter => {
        return getList(Object.assign(parameter, this.queryParam2))
          .then(res => {
            return res
          })
      },
      loadData3: parameter => {
        return getList(Object.assign(parameter, this.queryParam3))
          .then(res => {
            return res
          })
      },
      confirmLoading: false,
      zwpathVisible: false,
      zwpathData: {
        sub_id: 0,
        zwpath: ''
      },
      evaluateVisible: false,
      evaluateData: {
        teacher_point: 5,
        evaluate: ''
      }
    }
  },
  created () {
    // this.handelPre()
  },
  methods: {
    // handelPre () {
    //   getPre().then(res => {
    //     if (_.get(res, 'code') === 200) {
    //       this.dict.statusDict = _.get(res, 'values.statusDict', [])
    //     }
    //   })
    // },
    showEvaluateModal (record) {
      this.evaluateVisible = true
      this.evaluateData = {
        sub_id: record.sub_id,
        teacher_point: 5,
        evaluate: record.evaluate
      }
    },
    handleEvaluateOk () {
      this.confirmLoading = true
      saveEvaluate(this.evaluateData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.confirmLoading = false
          this.$refs.table2.refresh(true)
          this.evaluateVisible = false
          notification.success({
            message: '评价成功',
            description: '保存成功'
          })
        } else {
          this.confirmLoading = false
          notification.warning({
            message: '评价失败',
            description: '请稍后再试'
          })
        }
      })
    },
    onDateChange(date, dateString) {
      console.log(dateString)
      this.queryParam1.startTime=dateString[0]
      this.queryParam1.endTime=dateString[1]
      this.$refs.table1.refresh(true)
    },
    showZwModal (record) {
      this.zwpathVisible = true
      this.zwpathData = {
        sub_id: record.sub_id,
        zwpath: ''
      }
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const fileUrl = _.get(info.file, 'response.data.url')
        this.zwpathData.zwpath = path
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleZwpathChange (info) {
      this.handleFileUpload(info, 'zwpath')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    handleZwpathOk () {
      if (this.zwpathData.zwpath === '') {
        this.$message.warning('请上传作文')
        return false
      }
      this.confirmLoading = true
      saveZwpath(this.zwpathData).then(res => {
        if (_.get(res, 'code') === 200) {
          this.confirmLoading = false
          this.$refs.table1.refresh(true)
          this.zwpathVisible = false
          notification.success({
            message: '更新成功',
            description: '保存成功'
          })
        } else {
          this.confirmLoading = false
          notification.warning({
            message: '更新失败',
            description: '请稍后再试'
          })
        }
      })
    },
    // 开启更多查询方式
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 重置按钮
    reset1 () {
      this.queryParam1.tname = ''
      this.$refs.table1.refresh(true)
    },
    // 重置按钮
    reset2 () {
      this.queryParam2.tname = ''
      this.$refs.table2.refresh(true)
    },
    // 重置按钮
    reset3 () {
      this.queryParam3.tname = ''
      this.$refs.table3.refresh(true)
    },
    // 关闭查看按钮事件
    cancelViewDrawer () {
      this.viewVisible = false
    },
    // 打开查看抽屉
    openViewModal (id) {
      this.id = id
      this.viewVisible = true
    },
    // 在查看抽屉中完成编辑
    finishViewAndEdit () {
      this.$refs.table.refresh(true)
    },
    // 提交筛选
    handleSubmit1 (e) {
      e.preventDefault()
      this.$refs.table1.refresh(true)
    },
    handleSubmit2 (e) {
      e.preventDefault()
      this.$refs.table2.refresh(true)
    },
    handleSubmit3 (e) {
      e.preventDefault()
      this.$refs.table3.refresh(true)
    },
    // 切换提示
    toggleTableAlert () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    // 表格选择
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    // 批量操作按钮事件
    handleMenuClick (e) {
      if (e.key === '1') {
        const arrImages = []
        for (const i in this.selectedRows) {
        }
      }
    },
    handleCancelOk (subId) {
      saveCancel({ sub_id: subId }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('操作成功')
          this.$refs.table1.refresh(true)
          this.$refs.table3.refresh(true)
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>
